module.exports = __webpack_public_path__ + "img/account-multiple.60952247.svg";